module.exports = __webpack_public_path__ + "static/media/living-space_light.fbacb233.jpg";